import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

import Subscribe from '@/components/Public/subscribe'
import CharacterChoose from '@/components/Public/characterChoose'

// 问诊单详情页
import QuestionnaireDetail from '@/components/Public/questionnairePaper'
// 处方详情页
import PrescriptionDetail from '@/components/Public/prescriptionPaper'
// 医生端相关页面
import EnteringBaseInfo from '@/components/Doctor/Entering/baseInfo'
import EnteringCertification from '@/components/Doctor/Entering/certification'
import Waitting from '@/components/Doctor/Index/waittingEnter'
import FirstConfig from '@/components/Doctor/Index/firstConfigFee'
import Doctor from '@/components/Doctor/Index/index'
import DoctorIndex from '@/components/Doctor/Index/indexPage'
import ConsultingRoomIndex from '@/components/Doctor/Index/consultingRoom'
import Mine from '@/components/Doctor/Index/mine'
import InvitePatient from '@/components/Doctor/Invite/patient'
import InviteDoctor from '@/components/Doctor/Invite/doctor'
// 日程
import Schedule from '@/components/Doctor/Schedule/index'
import EditSchedule from '@/components/Doctor/Schedule/edit'
import ScheduleCata from '@/components/Doctor/Schedule/catalog'
import ScheduleOffLine from '@/components/Doctor/Schedule/offLine'
import ScheduleOffLineEdit from '@/components/Doctor/Schedule/offLineEdit'
// 诊疗室
import ChatList from '@/components/Doctor/ConsultingRoom/list'
import ChatIndex from '@/components/Doctor/ConsultingRoom/index'
import Chat from '@/components/Doctor/ConsultingRoom/chat'
import PatientRecord from '@/components/Doctor/ConsultingRoom/record'
import RecordDetail from '@/components/Doctor/ConsultingRoom/recordDetail'
// 处方模板
import PrescriptionIndex from '@/components/Doctor/Prescription/index'
import PrescriptionEdit from '@/components/Doctor/Prescription/edit'
// 诊断开方
import Diagnose from '@/components/Doctor/Diagnose/diagnose'
import ScriptEdit from '@/components/Doctor/Diagnose/scriptEdit'
// 西医开方
import DiagnoseWest from '@/components/Doctor/Diagnose/diagnoseWest'
import HerbWestEdit from '@/components/Doctor/Diagnose/herbWestEdit'
// 我的患者
import MinePatients from '@/components/Doctor/MinePatients/index'

// 医生个人中心相关页面
import DocProfile from '@/components/Doctor/Mine/profile'
import DocSalary from '@/components/Doctor/Mine/salary'
import DocCash from '@/components/Doctor/Mine/withdrawMoney'
import MedicalFee from '@/components/Doctor/Mine/medicalFeeConfig'

// 经方
import ClassicalPreList from '@/components/Doctor/ClassicalPrescription/list'
import ClassicalPreDetail from '@/components/Doctor/ClassicalPrescription/detail'


// 患者端相关页面
import PatientBaseInfo from '@/components/Patient/Entering/baseinfo'
import PatientMedicalRecord from '@/components/Patient/Entering/firstMedicalRecord'

// 绑定医生
import CodeBinding from '@/components/Public/codeBinding'
import Binding from '@/components/Public/binding'

// 首页
import Patient from '@/components/Patient/Index/index'
import PatientChatRoom from '@/components/Patient/Index/chatRoom'
import PatientMine from '@/components/Patient/Index/mine'

// 问诊单
import QuestionnaireIndex from '@/components/Patient/Questionnaire/index'
import QuestionnaireStepOne from '@/components/Patient/Questionnaire/stepOne'
import QuestionnaireStepTwo from '@/components/Patient/Questionnaire/stepTwo'
import QuestionnaireStepThree from '@/components/Patient/Questionnaire/stepThree'
// 西医问诊单
import WestenQuestionnaire from '@/components/Patient/Questionnaire/westenQuestionnaire'
import WestenQuestionnaireFemale from '@/components/Patient/Questionnaire/westenQuestionnaireFemale'

// 患者诊疗室
import PatientChatIndex from '@/components/Patient/ConsultingRoom/index'
import PatientChat from '@/components/Patient/ConsultingRoom/chat'
import MyRecord from '@/components/Patient/ConsultingRoom/record'

// 我的医生
import DoctorList from '@/components/Patient/MyDoctor/list'
import PatientDoctorDetail from '@/components/Patient/MyDoctor/detail'

// 患者预约医生
import Payment from '@/components/Patient/Payment/payment'

// 地址管理
import AddressList from '@/components/Patient/Address/list'
import AddressEdit from '@/components/Patient/Address/edit'

// 患者病历
import MedicalRecord from '@/components/Patient/MedicalRecord/index'
import MyRecordDetail from '@/components/Patient/MedicalRecord/detail'
// 患者添加病历
import AddRecord from '@/components/Patient/MedicalRecord/addRecord'

// 患者订单管理
import PatientOrderList from '@/components/Patient/Order/list'
import PatientOrder from '@/components/Patient/Order/detail'
import OrderPaySuccess from '@/components/Patient/Order/paySuccess'

// 患者修改个人资料
import PersonalEdit from '@/components/Patient/MedicalRecord/editPersonalInfo'

// 协议声明
import PatientStatement from '@/components/Agreement/patientStatement'
import DoctorStatement from '@/components/Agreement/doctorStatement'
import PatientAgreement from '@/components/Agreement/patientAgreement'
import DoctorAgreement from '@/components/Agreement/doctorAgreement'

// pdf预览页
import PdfPage from '@/components/Public/scriptPdf'

/*
新增模块部分
*/
//协定方
import PrivatePreList from '@/components/Doctor/PrivatePrescription/list'
import PrivatePreDetail from '@/components/Doctor/PrivatePrescription/detail'

// 诊断开方
import DiagnosePrivate from '@/components/Doctor/Diagnose/diagnosePrivate'
import PrivateEdit from '@/components/Doctor/Diagnose/privateEdit'
//import PrivateDiagnose from '@/components/Doctor/Diagnose/privatepres'
//面对面开药
import FaceToFace from '@/components/Doctor/ToFace/face'
//面对面开药跳转患者基本信息
import FaceToPatient from '@/components/Doctor/ToFace/patinfo'
//拍方上传
import DiagnosePhoto from '@/components/Doctor/Diagnose/diagnosePhoto'
import PhotoPresResult from '@/components/Common/presResult'

import EditCertification from '@/components/Doctor/Reload/certification'
//文章列表
import ArticleList from '@/components/Public/articleList'
import ArticleDetail from '@/components/Public/articleDetail'
//患者新首页
import PatientMain from '@/components/Patient/Index/main'
//患者分享医生二维码
import DocShareQrCode from '@/components/Public/docQrCodeShare'

import Disease from '@/components/Doctor/Disease/gb95'

import TestCode from '@/components/Public/TestCode'

import Banner1 from '@/components/Content/banner1'
import Banner2 from '@/components/Content/banner2'

import DiagnoseCoupon from '@/components/Patient/MyCoupon/diaCoupon'

import GroupDiagnose from '@/components/Doctor/Diagnose/diagnoseGroup'

import ReferralDetail from '@/components/Public/referralPaper'

import DocAppoint from '@/components/Patient/DocAppoint/appoint'

// 患者线下预约
import PayOffline from '@/components/Patient/Payment/offline'

import LogAppoint from '@/components/Doctor/SendLog/Appoint'
import LogCoupon from '@/components/Doctor/SendLog/Coupon'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      meta: {needAuth: true},
      component: HelloWorld
    },
    // 提示关注公众号
    {
      path: '/subscribe',
      name: 'Subscribe',
      meta: {title: '关注公众号'},
      component: Subscribe
    },
    // 角色选择
    {
      path: '/choose-role',
      name: 'CharacterChoose',
      meta: {title: '喜乐医生'},
      component: CharacterChoose
    },
    // 问诊单详情页
    {
      path: '/questionnaire-detail/:id',
      name: 'QuestionnaireDetail',
      meta: {title: '问诊单'},
      component: QuestionnaireDetail
    },
    // 处方详情页
    {
      path: '/prescription-detail/:id',
      name: 'PrescriptionDetail',
      meta: {title: '查看处方详情'},
      component: PrescriptionDetail
    },
    // 医生端相关路由
    {
      // 医生首页
      path: '/doctor',
      component: Doctor,
      children: [
        {
          path: '/',
          redirect: 'index'
        },
        {
          path: 'index',
          meta: {title: '喜乐医生'},
          component: DoctorIndex
        },
        {
          path: 'consulting-room',
          meta: {title: '诊疗室'},
          component: ChatList
        },
        {
          path: 'mine',
          meta: {title: '我的'},
          component: Mine
        },
      ]
    },
    // 入驻流程
    {
      // 入驻填写基本信息
      path: '/doctor/baseinfo',
      name: 'EnteringBaseInfo',
      meta: {title: '医生认证'},
      component: EnteringBaseInfo
    },
    {
      // 入驻填写认证信息
      path: '/doctor/certification',
      name: 'EnteringCertification',
      meta: {title: '医生认证'},
      component: EnteringCertification
    },
    {
      // 入驻等待审核
      path: '/doctor/waitting',
      name: 'Waitting',
      component: Waitting
    },
    // 审核通过首次设置医事服务费
    {
      path: '/doctor/first-config',
      meta: {title: '喜乐医生'},
      component: FirstConfig
    },
    // 我的患者
    {
      path: '/doctor/my-patients',
      name: 'MyPatients',
      meta: {title: '我的患者'},
      component: MinePatients
    },
    // 日程
  /*
    {
      // 日程列表
      path: '/doctor/schedule-online',
      name: 'Schedule',
      meta: {title: '诊疗日程'},
      component: Schedule
    },

    {
      // 新增
      path: '/doctor/edit-schedule',
      name: 'EditSchedule',
      meta: {title: '新增日程'},
      component: EditSchedule
    },
*/
    {
      // 医生首页
      path: '/doctor/schedule-catalog',
      component: ScheduleCata,
      children: [
        {
          path: '/',
          redirect: '/doctor/schedule-online'
      },
        {
          path: '/doctor/schedule-online',
          meta: {title: '线上诊疗日程'},
          component: Schedule
        },
        {
          path: '/doctor/schedule-offline',
          meta: {title: '线下诊疗日程'},
          component: ScheduleOffLine
        }
      ]
    },
    {
      // 新增
      path: '/doctor/edit-schedule',
      name: 'EditSchedule',
      meta: {title: '新增日程'},
      component: EditSchedule
    },
    {
      // 新增
      path: '/doctor/edit-offlineschedule',
      name: 'ScheduleOffLineEdit',
      meta: {title: '新增日程'},
      component: ScheduleOffLineEdit
    },


    // 诊疗室
    {
      path: '/chat-room/:id',
      component: ChatIndex,
      children: [{
        path: '/',
        name: 'ChatRoom',
        redirect: 'chat'
      },{
        path: 'chat',
        component: Chat
      }, {
        path: 'record',
        name: 'PatientRecord',
        component: PatientRecord
      }]
    },
    // 患者病历&问诊单详情
    {
      path: '/record-detail/:id',
      name: 'RecordDetail',
      component: RecordDetail,
    },
    // 处方模板
    {
      path: '/prescription',
      name: 'PrescriptionIndex',
      meta: {title: '我的处方模板'},
      component: PrescriptionIndex
    },
    // 编辑处方模板
    {
      path: '/prescription-edit',
      name: 'PrescriptionEdit',
      component: PrescriptionEdit
    },
    // 经方列表
    {
      path: '/classical-prescription',
      meta: {title: '经典方'},
      component: ClassicalPreList,
    },
    {
      path: '/classical-detail/:id',
      name: 'ClassicalDetail',
      meta: {title: '经方详情'},
      component: ClassicalPreDetail,
    },
    // 诊断开方
    {
      path: '/doctor/diagnose',
      name: 'Diagnose',
      meta: {title: '诊断开方'},
      component: Diagnose
    },
    // 开方编辑药方
    {
      path: '/doctor/diagnose/script',
      meta: {title: '编辑处方'},
      component: ScriptEdit
    },
    // 西医诊断开方
    {
      path: '/doctor/diagnoseWest',
      name: 'DiagnoseWest',
      meta: {title: '诊断开方'},
      component: DiagnoseWest
    },
    // 西医药品编辑
    {
      path: '/doctor/diagnoseWest/herbEdit',
      name: 'HerbWestEdit',
      component: HerbWestEdit
    },
    {
      // 邀请患者
      path: '/invite-patient',
      name: 'InvitePatient',
      component: InvitePatient
    },
    {
      // 邀请医生
      path: '/invite-doctor',
      name: 'InviteDoctor',
      component: InviteDoctor
    },
    // 医生资料页
    {
      path: '/doctor/profile',
      name: 'DocProfile',
      meta: {title: '个人资料'},
      component: DocProfile
    },
    // 我的薪资
    {
      path: '/doctor/salary',
      name: 'DocSalary',
      meta: {title: '我的薪资'},
      component: DocSalary
    },
    // 提现
    {
      path: '/doctor/withdraw',
      name: 'DocCash',
      meta: {title: '提现'},
      component: DocCash
    },
    // 设置医事服务费
    {
      path: '/doctor/fee-config',
      name: 'MedicalFee',
      meta: {title: '设置医事服务费'},
      component: MedicalFee
    },

    // 患者端相关路由
    {
      // 邀请码绑定
      path: '/patient/code-binding',
      name: 'CodeBinding',
      meta: {title: '喜乐医生'},
      component: CodeBinding,
    },
    {
      // 绑定医生
      path: '/patient/binding',
      name: 'Binding',
      meta: {title: '喜乐医生'},
      component: Binding,
    },
    {
      // 患者基本信息填写
      path: '/patient/baseinfo',
      name: 'PatientBaseInfo',
      component: PatientBaseInfo,
    },
    {
      // 患者首诊信息
      path: '/patient/medical-record',
      name: 'PatientMedicalRecord',
      component: PatientMedicalRecord,
    },
    /*
    {
      path: '/patient/chat-room',
      meta: {title: '诊疗室'},
      component: PatientChatRoom
    },
    */
    {
      path: '/patient',
      component: Patient,
      children: [
        {
          path: '/',
          redirect: 'main'
        },
        {
          path: 'main',
          meta: {title: '首页'},
          component: PatientMain
        },

        {
          path: 'chat-room',
          meta: {title: '诊疗室'},
          component: PatientChatRoom
        },

        {
          path: 'mine',
          meta: {title: '个人中心'},
          component: PatientMine
        },
      ]
    },
    // 问诊单
    {
      path: '/patient/questionnaire',
      component: QuestionnaireIndex,
      children: [
        {
          path: '/',
          redirect: 'step-one'
        },
        {
          path: 'step-one',
          name: 'QuestionnaireStepOne',
          meta: {title: '问诊单', questionnaire: true},
          component: QuestionnaireStepOne
        },
        {
          path: 'step-two',
          name: 'QuestionnaireStepTwo',
          meta: {title: '问诊单', questionnaire: true},
          component: QuestionnaireStepTwo
        },
        {
          path: 'step-three',
          name: 'QuestionnaireStepThree',
          meta: {title: '问诊单', questionnaire: true},
          component: QuestionnaireStepThree
        },
        {
          path: 'westen',
          name: 'QuestionnaireWesten',
          meta: {title: '问诊单', questionnaire: true},
          component: WestenQuestionnaire
        },
        {
          path: 'westenFemale',
          name: 'questionnaireWestenFemale',
          meta: {title: '问诊单', questionnaire: true},
          component: WestenQuestionnaireFemale
        },
      ]
    },
    // 诊疗室
    {
      path: '/patient/chat-room/:id',
      component: PatientChatIndex,
      children: [{
        path: '/',
        name: 'PatientChatRoom',
        redirect: 'chat'
      },{
        path: 'chat',
        component: PatientChat
      }, {
        path: 'record',
        component: MyRecord
      }]
    },
    {
      path: '/patient/doctor',
      name: 'DoctorList',
      meta: {title: '我的医生'},
      component: DoctorList,
    },
    {
      path: '/patient/doctor/detail/:id',
      name: 'PatientDoctorDetail',
      component: PatientDoctorDetail
    },
    // 患者预约医生
    {
      path: '/patient/order/payment',
      component: Payment
    },
    // 患者地址管理
    {
      path: '/patient/address/list',
      name: 'AddressList',
      meta: {title: '地址管理'},
      component: AddressList,
    },
    {
      path: '/patient/address/edit',
      name: 'AddressEdit',
      component: AddressEdit,
    },
    // 患者病历页
    {
      path: '/patient/my-medical-record',
      name: 'MedicalRecord',
      meta: {title: '我的病历'},
      component: MedicalRecord,
    },
    // 首诊&编辑首诊&病历&购买处方&问诊单详情页面
    {
      path: '/patient/record/detail',
      component: MyRecordDetail,
    },
    // 添加病历
    {
      path: '/patient/record/add',
      meta: {title: '添加病历'},
      component: AddRecord,
    },
    // 编辑个人资料
    {
      path: '/patient/info/edit',
      meta: {title: '修改个人资料'},
      component: PersonalEdit
    },
    // 患者我的订单
    {
      path: '/patient/order',
      meta: {title: '我的订单'},
      component: PatientOrderList
    },
    {
      path: '/patient/order/detail',
      meta: {title: '订单详情'},
      component: PatientOrder
    },
    {
      path: '/patient/order/success',
      meta: {title: '支付详情'},
      component: OrderPaySuccess,
    },


    // 用户协议相关
    {
      path: '/patient/statement',
      meta: {title: '法律声明与隐私条款'},
      component: PatientStatement
    },
    {
      path: '/patient/agreement',
      meta: {title: '用户注册协议'},
      component: PatientAgreement
    },
    {
      path: '/doctor/statement',
      meta: {title: '法律声明与隐私条款'},
      component: DoctorStatement
    },
    {
      path: '/doctor/agreement',
      meta: {title: '用户注册协议'},
      component: DoctorAgreement
    },

    // pdf预览页
    {
      path: '/pdf-viewer',
      component: PdfPage,
    },
    /*
    新增部分
    */
   // 主界面协定方列表
   {
     path: '/private-prescription',
     meta: {title: '协定方'},
     component: PrivatePreList,
   },
   {
     path: '/private-detail/:id',
     name: 'PrivateDetail',
     meta: {title: '协定方详情'},
     component: PrivatePreDetail,
   },
    // 诊断开方
    {
      path: '/doctor/diagnosePrivate',
      name: 'DiagnosePrivate',
      meta: {title: '诊断开方'},
      component: DiagnosePrivate
    },
    // 开方编辑药方
    {
      path: '/doctor/diagnose/privateEdit',
      meta: {title: '编辑处方'},
      component: PrivateEdit
    },
    {
      path: '/face-to-face',
      meta: {title: '面对面开药'},
      component: FaceToFace
    },

    {
      path: '/face-to-pat',
      meta: {title: '患者基本信息'},
      component: FaceToPatient
    },
    // 诊断开方
    {
      path: '/doctor/diagnose-photo',
      name: 'DiagnosePhoto',
      meta: {title: '拍方上传'},
      component: DiagnosePhoto
    },
    {
      path: '/prescription-result/:id',
      name: 'PhotoPresResult',
      meta: {title: '查看处方详情'},
      component: PhotoPresResult
    },
    //补充认证
    {
      // 入驻填写认证信息
      path: '/doctor/editcert',
      name: 'EditCertification',
      meta: {title: '补充认证'},
      component: EditCertification
    },
    //文章相关
    {
      // 入驻填写认证信息
      path: '/article',
      name: 'ArticleList',
      meta: {title: '文章'},
      component: ArticleList
    },
    {
      // 入驻填写认证信息
      path: '/article-detail',
      name: 'ArticleDetail',
      meta: {title: '文章详情'},
      component: ArticleDetail
    },
    {
      // 入驻填写认证信息
      path: '/patient/doc-share',
      name: 'DocShareQrCode',
      meta: {title: '分享医生'},
      component: DocShareQrCode
    },
    {
      // 入驻填写认证信息
      path: '/public/test-code',
      name: 'TestCode',
      meta: {title: '测试日志'},
      component: TestCode
    },
    {
      // 入驻填写认证信息
      path: '/disease/gb95',
      name: 'Disease',
      meta: {title: '疾病诊断'},
      component: Disease
    },
    {

      path: '/banner1',
      name: 'Banner1',
      meta: {title: '清华大学附属第二医院'},
      component: Banner1
    },
    {

      path: '/banner2',
      name: 'Banner2',
      meta: {title: '颜正华国医大师学术传承工作室'},
      component: Banner2
    },
    {
      path: '/patient/coupon',
      name: 'DiagnoseCoupon',
      meta: {title: '我的诊疗券'},
      component: DiagnoseCoupon
    },
    {
      path: '/doctor/diagnoseGroup',
      name: 'GroupDiagnose',
      meta: {title: '转诊单'},
      component: GroupDiagnose

    },
    {
      path: '/referralDetail/:id',
      name: 'ReferralDetail',
      meta: {title: '转诊单详情'},
      component: ReferralDetail

    },
    {
      path: '/patient/appoint',
      name: 'DocAppoint',
      meta: {title: '我的加号条'},
      component: DocAppoint
    },
    {
      path: '/patient/order/offline',
      component: PayOffline
    },
    {
      path: '/doctor/appoint',
      name: 'LogAppoint',
      meta: {title: '我发放的加号条'},
      component: LogAppoint
    },
    {
      path: '/doctor/coupon',
      name: 'LogCoupon',
      meta: {title: '我发放的诊疗券'},
      component: LogCoupon
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  beforeEach(to, from, next) {
    if(to.meta.questionnaire) {
      console.log(to);
      next();
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js